import React from "react";
import PropTypes from "prop-types";

const propTypes = {
  onClick: PropTypes.func.isRequired,
  envprops: PropTypes.shape({
    BackgroundColor: PropTypes.string.isRequired,
  }).isRequired,
};

const TopNavToggler = ({ onClick, envprops }) => {
  return (
    <div
      className="app-topnav-toggler"
      style={{ backgroundColor: envprops.BackgroundColor }}
    >
      <button
        type="button"
        className="navbar-toggler"
        onClick={onClick}
        aria-label="Toggle navigation"
      >
        <span className="navbar-toggler-icon"></span>
      </button>
    </div>
  );
};

TopNavToggler.propTypes = propTypes;

export default TopNavToggler;
